import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 784,
      lg: 1024,
      xl: 1200,
    },
  },
  palette: {
    primary: {
      main: "#2563EB", // Modern Blue
      light: "#60A5FA",
      dark: "#1E40AF",
    },
    secondary: {
      main: "#10B981", // Emerald Green
      light: "#34D399",
      dark: "#059669",
    },
    error: {
      main: "#EF4444", // Red
      light: "#F87171",
      dark: "#DC2626",
    },
    warning: {
      main: "#F59E0B", // Amber
      light: "#FBBF24",
      dark: "#D97706",
    },
    info: {
      main: "#3B82F6", // Blue
      light: "#60A5FA",
      dark: "#2563EB",
    },
    success: {
      main: "#10B981", // Emerald Green
      light: "#34D399",
      dark: "#059669",
    },
    background: {
      default: "#FFFFFF", // White
      paper: "#F9FAFB", // Light Gray
    },
    text: {
      primary: "#111827", // Dark Gray
      secondary: "#4B5563", // Medium Gray
    },
  },
  typography: {
    fontFamily: [
      "Inter",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: {
      fontSize: "2.5rem",
      fontWeight: 600,
      color: "#111827",
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 600,
      color: "#111827",
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 600,
      color: "#111827",
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
      color: "#111827",
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 600,
      color: "#111827",
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 600,
      color: "#111827",
    },
    button: {
      textTransform: "none",
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
          fontWeight: 500,
          padding: "8px 16px",
        },
        contained: {
          backgroundColor: "#2563EB",
          color: "#FFFFFF",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "#1E40AF",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          },
        },
        outlined: {
          borderColor: "#E5E7EB",
          color: "#4B5563",
          "&:hover": {
            borderColor: "#2563EB",
            backgroundColor: "rgba(37, 99, 235, 0.04)",
          },
        },
        text: {
          color: "#2563EB",
          "&:hover": {
            backgroundColor: "rgba(37, 99, 235, 0.04)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: "#FFFFFF",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          "&:hover": {
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 8,
            "& fieldset": {
              borderColor: "#E5E7EB",
            },
            "&:hover fieldset": {
              borderColor: "#2563EB",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#2563EB",
            },
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          color: ownerState.color === "inherit" ? "inherit" : "#2563EB",
          textDecoration:
            ownerState.underline === "always" ? "underline" : "none",
          "&:hover": {
            textDecoration:
              ownerState.underline === "none" ? "none" : "underline",
          },
        }),
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "#111827",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        },
      },
    },
  },
});

export default theme;
